import { styled, Flex, $primaryColors } from '@acko-tech/building-blocks.ui.common'
import { Text } from '@acko-tech/building-blocks.ui.typography'

export const Root = styled(Flex)`
  flex-direction: column;
  align-items: center;
  padding-top: 150px;
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 20px;
    padding-top: 100px;
  }
`
export const Message = styled(Text)`
  font-size: 20px;
  line-height: 24px;
  font-weight: 600;
  color: #000;
  text-align: center;
  max-width: 600px;
  padding: 0 20px;
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 20px;
    max-width: 400px;
  }
`

export const Button = styled(Flex)`
  width: 100%;
  margin-top: 40px;
  position: relative;
  background: ${$primaryColors.normal};
  border-radius: 6px;
  height: ${props => (props.showLoader ? '16px' : 'auto')};
  padding: 16px 18px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  min-width: 125px;
  max-width: 250px;
  transition: all 0.3s linear;
  &:hover {
    background: ${$primaryColors.dark};
  }
`

export const ButtonText = styled(Text)`
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: #fff;
`
